
export default (state = [], action)=>{
    switch (action.type) {
        case "set-available-widget-locales":
            return action.data;
        default:
            return state;
    }
}
